import React from "react";

import styles from "../../../../styles/pages/user/managerdashboard/verifiedvideosconfirmed.module.scss";

import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import { Box } from "@mui/system";
import { Button, Tab, TableContainer, Tabs, Typography } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import PendingPublicationIcon from "../../../../public/assets/icons/PendingPublicationIcon";
import PublishedVideoIcon from "../../../../public/assets/icons/PublishedVideoIcon";
import OpenMessageIcon from "../../../../public/assets/icons/OpenMessageIcon";
import CalenderIcon from "../../../../public/assets/icons/CalenderIcon";
import ApprovedVideoIcon from "../../../../public/assets/icons/ApprovedVideoIcon";
import WebsiteIcon from "../../../../public/assets/icons/WebsiteIcon";
import RejectedVideoIcon from "../../../../public/assets/icons/RejectedVideoIcon";
import ReviewVideoFilter from "../../../../components/ReviewdVideoFilter/ReviewVideoFilter";
import ApprovedVideoTable from "../../../../components/ApprovedvideoTable/ApprovedVideoTable";
import ReviewdVideoMenu from "../../../../components/ReviewdVideoMenu/ReviewdVideoMenu";
import WebsiteVideoTable from "../../../../components/WebsiteVideoTable/WebsiteVideoTable";
import VerifiedVideoMenu from "../../../../components/VerifiedVideoMenu/VerifiedVideoMenu";
import TabArrow from "../../../../public/assets/icons/TabArrow";
import VerifiedConfirmApprovedTable from "../../../../components/VerifiedConfirmApprovedTable/VerifiedConfirmApprovedTable";
import VerifyConfrmApprvFilter from "../../../../components/VerifyConfrmApprvFilter/VerifyConfrmApprvFilter";
import VerifiedConfirmedWebsiteTable from "../../../../components/VerifiedConfirmedWebsiteTable/VerifiedConfirmedWebsiteTable";
import VerifyConfrmWebsiteFilter from "../../../../components/VerifyConfrmWebsiteFilter/VerifyConfrmWebsiteFilter";
import VerifiedConfirmedRejectedTable from "../../../../components/VerifiedConfirmedRejectedTable/VerifiedConfirmedRejectedTable";
import VerifyConfirmedRejectedFilter from "../../../../components/VerifyConfirmedRejectedFilter/VerifyConfirmedRejectedFilter";
import QcagentDasboard from "../QcagentDasboard";
import QcDashboardWrapper from "../../../../layout/wrapper/QcDashboradWrapper";
import QcVerifiedConfirmApprovedTable from "../../../../components/QcVerifiedConfirmApprovedTable/QcVerifiedConfirmApprovedTable";
import QcVerifyConfrmApprvFilter from "../../../../components/QcVerifyConfrmApprvFilter/QcVerifyConfrmApprvFilter";
import QcVerifyConfrmWebsiteFilter from "../../../../components/QcVerifyConfrmWebsiteFilter/QcVerifyConfrmWebsiteFilter";
import QcVerifiedConfirmedWebsiteTable from "../../../../components/QcVerifiedConfirmedWebsiteTable/QcVerifiedConfirmedWebsiteTable";
import QcVerifyConfirmedRejectedFilter from "../../../../components/QcVerifyConfirmedRejectedFilter/QcVerifyConfirmedRejectedFilter";
import QcVerifiedVideoMenu from "../../../../components/QcVerifiedVideoMenu/QcVerifiedVideoMenu";
import QcVerifiedConfirmConfirmTab from "./QcVerifiedConfirmConfirmTab";
import QcVerifiedApprovedApprovedTab from "./QcVerifiedApprovedApprovedTab";
import QcVerifiedWebsiteWebsiteTab from "./QcVerifiedWebsiteWebsiteTab";
import QcVerifiedRejectedRejectedTab from "./QcVerifiedRejectedRejectedTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function QcVerifiedVideosConfirmed() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /*************************************/

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <QcDashboardWrapper>
      <Box className={styles.reviewd_videos_wrapper}>
        <Box className={styles.reviewVideoMenu}>
          <QcVerifiedVideoMenu />
        </Box>

        <Box className={styles.video_tab}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Approved</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Approved</Typography>
                  </Box>
                </>
              }
              {...a11yProps(0)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Website Only</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Website Only</Typography>
                  </Box>
                </>
              }
              {...a11yProps(1)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Rejected</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Rejected</Typography>
                  </Box>
                </>
              }
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>

        <Box className={styles.reviewVideoTabMain}>
          <CustomTabPanel value={value} index={0}>
            <QcVerifiedApprovedApprovedTab />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedWebsiteWebsiteTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <QcVerifiedRejectedRejectedTab />
          </CustomTabPanel>
        </Box>
      </Box>
    </QcDashboardWrapper>
  );
}
